import { render, staticRenderFns } from "./SummaryReportTabs.vue?vue&type=template&id=ed80901e"
import script from "./SummaryReportTabs.vue?vue&type=script&lang=js"
export * from "./SummaryReportTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports